export default __webpack_public_path__ + "static/media/loader.9f8fe5e9.gif";